<template>
  <section>
    <Header />
    <main class="main animated fadeIn faster" :class="{ 'expand-main': false }">
      <div class="row px-2">
        <div class="col-md-12">
          <div class="row d-flex flex-row px-0 mx-0">
            <div class="col-12 px-0"></div>
            <h4 class="mb-3 ml-2">Smartlead Emails Statistics</h4>
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Email</th>
                  <th class="text-center">Total Sent</th>
                  <th class="text-center">Total Reply</th>
                  <th class="text-center">Total Remove spam</th>
                  <th class="text-center">Warmup Reputation</th>
                  <th>Status</th>
                  <th>Error</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(group, index) in emails">
                  <!-- fila principal -->
                  <tr :key="group.email + '-row'">
                    <td class="font-weight-bold">{{ group.email }}</td>
                    <td class="text-center">{{ group.total_sent }}</td>
                    <td class="text-center">{{ group.total_reply }}</td>
                    <td class="text-center">{{ group.latest.total_remove_spam }}</td>
                    <td class="text-center">{{ group.latest.warmup_reputation }}</td>
                    <td>
                      <span
                        class="badge"
                        :class="{
                          'badge-success': group.status === 'ACTIVE',
                          'badge-warning': group.status === 'PAUSED' || group.status === 'PENDING',
                          'badge-danger': group.status === 'INACTIVE' 
                        }"
                      >
                        {{ group.status || 'UNKNOWN' }}
                      </span>
                    </td>
                    <td>
                      <span v-if="group.hasError && group.status!='ACTIVE'" class="text-danger">Sí</span>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td class="text-right">
                      <button class="btn btn-sm btn-link" @click="toggle(group.email)">
                        {{ isOpen(group.email) ? 'hide' : 'last 5 days' }}
                      </button>
                    </td>
                  </tr>

                  <!-- fila collapse justo debajo -->
                  <tr v-show="isOpen(group.email)" :key="group.email + '-history'">
                    <td colspan="6" class="p-0">
                      <div class="p-2">
                        <small class="text-muted">last 5 days</small>
                        <table class="table table-sm mb-0 mt-2">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th class="text-center">Sent</th>
                              <th class="text-center">Reply</th>
                              <th class="text-center">Remove spam</th>
                             
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="day in group.history" :key="group.email + '-' + day.date">
                              <td>{{ formatDate(day.date) }}</td>
                              <td class="text-center">{{ day.sent }}</td>
                              <td class="text-center">{{ day.reply }}</td>
                              <td class="text-center">{{ day.remove_spam || 0 }}</td>
                              
                            </tr>
                            <tr v-if="!group.history || group.history.length === 0">
                              <td colspan="5" class="text-center text-muted">No hay datos</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { adminService } from "@/_services";
import { mapActions } from "vuex";

export default {
  name: "SmartleadEmails",
  props: {
    recordsProp: {
      type: Array,
      required: false,
      default: null
    },
    apiEndpoint: {
      type: String,
      required: false,
      default: "/admin/smartlead-stats"
    }
  },
  data() {
    return {
      openEmails: {},
      emails: []
    };
  },
  created() {
    if (this.recordsProp && Array.isArray(this.recordsProp)) {
      this.records = this.recordsProp;
    } else {
      this.fetchStats();
    }
  },
  mounted() {
    this.setDashboardHeader();
  },
  watch: {
    recordsProp(val) {
      if (val) this.records = val;
    }
  },

  methods: {
    ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    setDashboardHeader(){
      this.setCurrentRoute({ page: "smartlead-emails-stats", label: "Smartlead Emails Statistics" });
      this.setCurrentRouteChild({ child: "" });
    },
    async fetchStats() {
      try {
        const resp = await adminService.getSmartleadStats();
        const data = (resp && resp.result) ? resp.result : (Array.isArray(resp) ? resp : []);
        this.emails = data;
      } catch (e) {
        console.error("Error fetching smartlead stats", e);
        this.records = [];
      }
    },
    toggle(email) {
      this.$set(this.openEmails, email, !this.openEmails[email]);
    },
    isOpen(email) {
      return !!this.openEmails[email];
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      return (dateStr + "").substr(0, 10);
    }
  }
};
</script>

<style scoped>
.badge-success { background: #34f148; color: #fff; }
.badge-warning { background: #f0ad4e; color: #fff; }
.badge-danger { background: #dc3545; color: #fff; }
.table-sm td, .table-sm th { vertical-align: middle; }
</style>